module.exports = __webpack_public_path__ + "static/media/22.7571cbf4.JPG";